module.exports = __webpack_public_path__ + "static/media/food_beach_3.fe9dd460.svg";